import { formatLanguageLabel } from "@/shared/lib/labels";

/** Opção para select (paridade GUI: timeZones.root, supportedLanguages string). */
export type SelectOption = { value: string; label: string };
type TZChild = {
  name?: string;
  displayName?: string;
  str?: string;
  id?: string;
  text?: string;
};

export function normalizeTimeZoneOptions(data: unknown): SelectOption[] {
  if (!data) return [];

  const mapChild = (tz: TZChild): SelectOption => ({
    value: String(tz.name ?? tz.id ?? ""),
    label: String(tz.str ?? tz.text ?? tz.displayName ?? tz.name ?? tz.id ?? ""),
  });

  if (Array.isArray(data)) {
    return data.map((tz) => mapChild(tz as TZChild)).filter((o) => o.value);
  }

  const root = (data as { root?: TZChild[] }).root;
  if (Array.isArray(root)) {
    return root.map(mapChild).filter((o) => o.value);
  }

  return [];
}

export function normalizeLanguageOptions(data: unknown): SelectOption[] {
  if (!data) return [];

  if (typeof data === "string") {
    return data
      .split(/\s+/)
      .filter(Boolean)
      .map((v) => ({ value: v, label: formatLanguageLabel(v) }));
  }

  if (Array.isArray(data)) {
    return data
      .map((lang) => {
        if (typeof lang === "string") {
          return { value: lang, label: formatLanguageLabel(lang) };
        }
        const row = lang as { id?: string; text?: string; name?: string };
        const value = String(row.id ?? row.name ?? row.text ?? "");
        const label = formatLanguageLabel(value);
        return { value, label };
      })
      .filter((o) => o.value);
  }

  return [];
}
